/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
// import { faEngineWarning } from '@fortawesome/pro-solid-svg-icons';
import { Col, Row, Nav, Navbar, Form, Button, ButtonToolbar, OverlayTrigger, Popover } from 'react-bootstrap';
import CryptoAES from 'crypto-js/aes';
import CryptoEnc from 'crypto-js/enc-utf8';
import { Navigate } from 'react-router';
import config from '../../config';
import CDATA from 'Services/CDATA';
import { RegEditView, RegEditBody, Toolbar, Spinner, GButton } from './RegulationEditor.styles';
import AppContext from 'AppContext';
import 'Styles/SCSS/ag-theme-material.scss';

const { encKey } = config.sessionStorage;

class EPTv2editor extends Component {
  constructor(props) {
    super(props);

    let sessionState = sessionStorage.getItem('PageStateStorage');
    let propsID = this.props.location.classcode_bk;
    // console.log(propsID)
    if (propsID) {
      this.state = {
        page: window.location.pathname,
        raw_api: this.props.raw_api,
        api_name: this.props.location.api_name,
        loading: false,
        failed: false,
        Class_Code: this.props.location.classcode_bk,
        Fund_Code: this.props.location.fundcode_bk,
        Reference_Language: this.props.location.language,
        eventKey: 'General Info',
        action_type: this.props.location.action_type,
        toolbarButtons: [
          'Placeholder' === 'Edit' ? (
            <GButton
              key={0}
              onClick={() => { this.handleApprove(); }}
              size="Medium"
              type="Primary"
              text="Approve"
            />
          ) : (
            <GButton
              key={0}
              onClick={() => { this.handleReject(); }}
              size="Medium"
              type="Primary"
              text="Re-Open"
            />
          )
        ],
        validated: false,
        loaded: false,
        redirect: false,
      };
      sessionStorage.setItem('PageStateStorage', CryptoAES.encrypt(JSON.stringify(this.state), encKey));
    } else if (sessionState && JSON.parse(CryptoAES.decrypt(sessionState.toString(), encKey).toString(CryptoEnc)).page === window.location.pathname) {
      this.state = JSON.parse(CryptoAES.decrypt(sessionState.toString(), encKey).toString(CryptoEnc));
    } else {
      this.state = { redirect: true };
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  async componentDidMount() {
    const urlParameters = CDATA.addFilter(`ClientCode_bk eq '${this.context.state.selectedClient.code}' and x_00070_Reference_Date eq '${this.context.state.selectedReportingDate.code}' and x_04010_Reference_Language eq '${this.state.Reference_Language}' and x_00030_Portfolio_Identifying_Data eq '${this.state.Class_Code}'`);
    try {
      const data = await CDATA.makeRequest(
        'GET',
        'PRIIPS_app_EPT_OUTPUT',
        urlParameters,
        {},
        'Error retrieving data.',
      );

      let eptFields = data.value[0];
      // console.log(data);

      this.setState(eptFields);
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  async saveEPT(eptSection) {
    if (eptSection === 'General') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_ManCo: this.state.x_00010_Portfolio_Issuer_Name,
            OF_Fund_Guarantor: this.state.x_00020_Portfolio_Guarantor_Name,
            ClassCode_bk: this.state.x_00030_Portfolio_Identifying_Data,
            EPT_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio: this.state.x_00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio,
            OF_Full_Share_Class_Name: this.state.x_00050_Portfolio_Name,
            OF_Share_Class_Currency: this.state.x_00060_Share_Class_Currency,
            Reference_Date: this.state.x_00070_Reference_Date,
            OF_PRIIP_Category: this.state.x_00080_Portfolio_PRIIPS_Category,
            EPT_Fund_CIC_code: this.state.x_00090_Fund_CIC_code,
            OF_Is_Fund_Targeting_Environmental_Or_Social_Objectives_EOS: this.state.x_00100_EOS_portfolio,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    } else if (eptSection === 'Costs') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_Subscription_Fee_Maximum: this.state.x_03010_One_off_cost_Portfolio_entry_cost,
            OF_PRIIPS_Subscription_Fee_In_Favour_Of_Fund: this.state.x_03015_One_off_cost_Portfolio_entry_cost_Acquired,
            OF_PRIIPS_Redemption_Fee_In_Favour_Of_Fund_At_RHP: this.state.x_03020_One_off_costs_Portfolio_exit_cost_at_RHP,
            OF_PRIIPS_Redemption_Fee_In_Favour_Of_Fund_At_1_Year: this.state.x_03030_One_off_costs_Portfolio_exit_cost_at_1_year,
            OF_PRIIPS_Redemption_Fee_In_Favour_Of_Fund_At_Half_RHP: this.state.x_03040_One_off_costs_Portfolio_exit_cost_at_half_RHP,
            OF_PRIIP_One_off_Sliding_Exit_Cost_Indicator: this.state.x_03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator,
            OF_PRIIPS_Other_Ongoing_Costs: this.state.x_03060_Ongoing_costs_Portfolio_other_costs,
            OF_PRIIPS_Management_Costs: this.state.x_03070_Ongoing_costs_Portfolio_management_costs,
            OF_PRIIPS_Ongoing_Transaction_Costs: this.state.x_03080_Ongoing_costs_Portfolio_transaction_costs,
            OF_Has_PRIIPS_Performance_Fee: this.state.x_03090_Existing_performance_fees,
            OF_PRIIPS_Performance_Fee: this.state.x_03095_Incidental_costs_Portfolio_performance_fees,
            OF_Has_PRIIPS_Carried_Interest: this.state.x_03100_Existing_carried_interest_fees,
            OF_PRIIPS_Carried_Interest: this.state.x_03105_Incidental_costs_Portfolio_carried_interest,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    } else if (eptSection === 'Risk') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_Valuation_Frequency: this.state.x_01010_Valuation_Frequency,
            OF_PRIIP_VEV: this.state.x_01020_Portfolio_VEV_Reference,
            OF_Is_PRIIP_Flexible: this.state.x_01030_IS_Flexible,
            OF_Flexible_PRIIP_VEV: this.state.x_01040_Flex_VEV_Historical,
            OF_Flexible_PRIIP_Asset_Allocation_VEV: this.state.x_01050_Flex_VEV_Ref_Asset_Allocation,
            OF_Has_Risk_Limit: this.state.x_01060_IS_Risk_Limit_Relevant,
            OF_Flexible_PRIIP_VEV_Limit: this.state.x_01070_Flex_VEV_Risk_Limit,
            OF_Has_PRIIP_Credit_Risk: this.state.x_01080_Existing_Credit_Risk,
            OF_PRIIP_Summary_Risk_Indicator: this.state.x_01090_SRI,
            OF_PRIIP_Market_Risk_Measure: this.state.x_01100_MRM,
            OF_PRIIP_Credit_Risk_Measure: this.state.x_01110_CRM,
            OF_PRIIP_Recommended_Holding_Period: this.state.x_01120_Recommended_Holding_Period,
            OF_Maturity_Date: this.state.x_01130_Maturity_Date,
            OF_PRIIP_Liquidity_Risk: this.state.x_01140_Liquidity_Risk,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    } else if (eptSection === 'Performance') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_PRIIP_Return_1Y_Unfavourable: this.state.x_02010_Portfolio_return_unfavorable_scenario_1_year,
            OF_PRIIP_Return_Half_RHP_Unfavourable: this.state.x_02020_Portfolio_return_unfavorable_scenario_half_RHP,
            OF_PRIIP_Return_RHP_Unfavourable: this.state.x_02030_Portfolio_return_unfavorable_scenario_RHP,
            OF_PRIIP_Return_1Y_Moderate: this.state.x_02040_Portfolio_return_moderate_scenario_1_year,
            OF_PRIIP_Return_Half_RHP_Moderate: this.state.x_02050_Portfolio_return_moderate_scenario_half_RHP,
            OF_PRIIP_Return_RHP_Moderate: this.state.x_02060_Portfolio_return_moderate_scenario_RHP,
            OF_PRIIP_Return_1Y_Favourable: this.state.x_02070_Portfolio_return_favorable_scenario_1_year,
            OF_PRIIP_Return_Half_RHP_Favourable: this.state.x_02080_Portfolio_return_favorable_scenario_half_RHP,
            OF_PRIIP_Return_RHP_Favourable: this.state.x_02090_Portfolio_return_favorable_scenario_RHP,
            OF_PRIIP_Return_1Y_Stress_Scenario: this.state.x_02100_Portfolio_return_stress_scenario_1_year,
            OF_PRIIP_Return_Half_RHP_Stress_Scenario: this.state.x_02110_Portfolio_return_stress_scenario_half_RHP,
            OF_PRIIP_Return_RHP_Stress_Scenario: this.state.x_02120_Portfolio_return_stress_scenario_RHP,
            OF_PRIIP_Number_Of_Observed_Returns: this.state.x_02130_Portfolio_number_of_observed_return_M0,
            OF_PRIIP_MRM_Mean_Return: this.state.x_02140_Portfolio_mean_observed_returns_M1,
            OF_PRIIP_MRM_Sigma: this.state.x_02150_Portfolio_observed_Sigma,
            OF_PRIIP_MRM_Skewness: this.state.x_02160_Portfolio_observed_Skewness,
            OF_PRIIP_MRM_Excess_Kurtosis: this.state.x_02170_Portfolio_observed_Excess_Kurtosis,
            OF_PRIIP_Volatility_Of_Stressed_Scenario: this.state.x_02180_Portfolio_observed_Stressed_Volatility,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    } else if (eptSection === 'Narratives') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_PRIIP_Filing_Language: this.state.x_04010_Reference_Language,
            OF_MIFID_Securities_Classification: this.state.x_04020_Comprehension_Alert_Portfolio,
            OF_Target_Market_Retail_Investor_Type: this.state.x_04030_Intended_target_market_retail_investor_Portfolio,
            OF_Investment_Objective: this.state.x_04040_Investment_objective_Portfolio,
            OF_PRIIP_Risk_Narrative: this.state.x_04050_Risk_narrative_Portfolio,
            OF_PRIIP_Other_Risk_Narrative: this.state.x_04060_Other_materially_relevant_risk_narrative_Portfolio,
            OF_PRIIP_Investment_Option: this.state.x_04070_Type_of_underlying_Investment_Option,
            OF_Has_PRIIP_Capital_Guarantee: this.state.x_04080_Capital_Guarantee,
            OF_PRIIP_Capital_Guarantee_Level: this.state.x_04081_Capital_Guarantee_Level,
            OF_PRIIP_Capital_Guarantee_Limitations: this.state.x_04082_Capital_Guarantee_Limitations,
            OF_PRIIP_Capital_Guarantee_Early_Exit_Conditions_Date: this.state.x_04083_Capital_Guarantee_Early_Exit_Conditions,
            OF_PRIIP_Capital_Guarantee_Characteristics: this.state.x_04084_Capital_guarantee_Portfolio,
            OF_PRIIP_Possible_Maximum_Loss: this.state.x_04085_Possible_maximum_loss_Portfolio,
            OF_PRIIPS_Performance_Fee_Description: this.state.x_04090_Portfolio_Performance_Fees_Narrative,
            OF_PRIIPS_Carried_Interest_Description: this.state.x_04100_Portolio_Carried_Interest_Narrative,
            OF_PRIIP_Other_Comment: this.state.x_04110_Other_comment,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    } else if (eptSection === 'Other') {
      try {
        const data = await CDATA.makeRequest(
          'PUT',
          'PRIIPS_App_EPT(' + this.state.RECORD_ID + ')',
          '',
          {
            Version: (this.state.Version + 0.001),
            ClientCode_bk: this.state.Client_Code,
            FundCode_bk: this.state.Fund_Code,
            Status: this.state.Status,
            UpdatedBy: this.props.mail,
            OF_Has_PRIIP_Data_Delivery: this.state.x_05010_PRIIP_data_delivery,
            OF_Has_UCITS_Data_Delivery: this.state.x_05020_UCITS_data_delivery,
            OF_SRRI: this.state.x_05030_Portfolio_UCITS_SRRI,
            OF_Historical_Volatility: this.state.x_05040_Portfolio_UCITS_Vol,
            OF_Ongoing_Charges: this.state.x_05050_Ongoing_costs_Portfolio_other_costs_UCITS,
            OF_Portfolio_Transaction_Costs_05060: this.state.x_05060_Ongoing_costs_Portfolio_transaction_costs,
            OF_Methodology_Of_Transaction_Costs: this.state.x_05065_Transactions_costs_methodology,
            OF_Performance_Fee_Applied: this.state.x_05070_Incidental_costs_Portfolio_performance_fees_UCITS,
            OF_UCITS_Incidental_Costs_Carried_Interest: this.state.x_05080_Incidental_costs_Portfolio_carried_interest_UCITS,
            OF_UCITS_KID_URL: this.state.x_05090_UCITS_KID_Web_Address,
            OF_Bond_Weight: this.state.x_06010_Bonds_Weight,
            OF_Annualized_Volatility: this.state.x_06020_Annualized_Return_Volatility,
            OF_Macaulay_Duration: this.state.x_06030_Duration_Bonds,
            OF_Has_Capital_Preservation: this.state.x_06040_Existing_Capital_Preservation,
            OF_Capital_Preservation_Level: this.state.x_06050_Capital_Preservation_Level,
            OF_Capital_Preservation_Period: this.state.x_06060_Time_Interval_Maximum_Loss,
            OF_Has_CPPI: this.state.x_06070_Uses_PI,
            OF_CPPI_Multiplier: this.state.x_06080_Multiplier_PI,
            OF_1Y_Total_Costs: this.state.x_07010_Total_cost_1_year,
            OF_1Y_RIY: this.state.x_07020_RIY_1_year,
            OF_Half_RHP_Total_Costs: this.state.x_07030_Total_cost_half_RHP,
            OF_Half_RHP_RIY: this.state.x_07040_RIY_half_RHP,
            OF_RHP_Total_Costs: this.state.x_07050_Total_cost_RHP,
            OF_RHP_RIY: this.state.x_07060_RIY_RHP,
            OF_PRIIPS_One_off_Entry_Costs: this.state.x_07070_One_off_costs_Portfolio_entry_cost_RIY,
            OF_PRIIPS_One_off_Exit_Costs: this.state.x_07080_One_off_costs_Portfolio_exit_cost_RIY,
            OF_Portfolio_Transaction_Costs: this.state.x_07090_Ongoing_costs_Portfolio_transaction_costs_RIY,
            OF_PRIIPS_Other_Ongoing_Costs_RIY: this.state.x_07100_Ongoing_costs_Other_ongoing_costs_RIY,
            OF_PRIIPS_Performance_Fee_RIY: this.state.x_07110_Incidental_costs_Portfolio_performance_fees_RIY,
            OF_PRIIPS_Carried_Interest_RIY: this.state.x_07120_Incidental_costs_Portfolio_carried_interests_RIY,
          },
          'EPT saved successfully',
        );
        this.setState({ Version: this.state.Version + 0.001 });
      } catch (err) {
        this.setState({
          loading: false,
          failed: true,
          failMessage: 'EPT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
        });
      }
    }
  }

  handleSubmit(event, eptSection) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ validated: true, Status: 'Ready for Review' });
      this.saveEPT(eptSection);
      event.preventDefault();
      event.stopPropagation();
      // console.log('here')
    } else {
      event.preventDefault();
      this.setState({ validated: true, Status: 'Ready for Review' });
      this.saveEPT(eptSection);
    }
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    // console.log(target.name);

    this.setState({
      [name]: value,
    });
    sessionStorage.setItem('PageStateStorage', CryptoAES.encrypt(JSON.stringify(this.state), encKey));
  }

  handleSelectChange(selectedItems) {
    this.setState({ selectedItems });
  }

  disableValidation() {
    this.setState({ validated: false });
  }

  handleApprove(event) {
    const modalContent = <div><p>Approving {this.state.Class_Code} EPT...</p></div>;
    this.context.handlers.setModal('Approving ...', modalContent, null, null, true);

    CDATA.makeRequest(
      'POST',
      'PRIIPS_App_APPROVE_EPT_BULK',
      '',
      {
        ClientCode_bk: this.context.state.selectedClient.code,
        RecordIDList: this.state.RECORD_ID.toString(),
        UserName: this.context.state.userEmail,
      },
      'Approve failed.',
    )
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You successfully approved the EPT for Portfolio: '}
              <span>{this.state.Class_Code}</span>
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ action_type: 'View', status: 'Approved' });
        this.refreshData();
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to approve the EPT for the Portfolio:'}
              <span> {this.state.Class_Code} </span>
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  handleReject(event) {
    const modalContent = <div><p>Re Opening {this.state.Class_Code} EPT...</p></div>;
    this.context.handlers.setModal('Re Opening ...', modalContent, null, null, true);

    CDATA.makeRequest(
      'POST',
      'PRIIPS_App_REOPEN_EPT_BULK',
      '',
      {
        ClientCode_bk: this.context.state.selectedClient.code,
        RecordIDList: this.state.RECORD_ID.toString(),
        UserName: this.context.state.userEmail,
      },
      'Re-Open failed.',
    )
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'EPT re-opened successfully for the ClassCode_bk: '}
              <span>{this.state.Class_Code}</span>
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ action_type: 'Edit', status: 'Ready for review' });
        this.refreshData();
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to re-open the EPT for the ClassCode_bk'}
              <span> {this.state.Class_Code} </span>
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  refreshData() {
    this.setState({ loading: false }, () => this.saveEPT());
  }

  render() {
    return (
      this.state.redirect === true ? <Navigate to="/regulatory-reporting/ept/dashboard" /> : (
        <RegEditView>
          <RegEditBody>
            {
              // this.state.failed ? <Error text={this.state.failMessage} /> : (
              <>
                <Navbar style={{ backgroundColor: '#e9e8f0' }}>
                  <Nav class="nav nav-tabs" style={{ backgroundColor: '#e9e8f0', marginLeft: -15 }} onSelect={(selectedKey) => this.setState({ eventKey: selectedKey } )} onClick={() => { this.disableValidation(); }}>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="General Info">General Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Costs">Costs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Risk">Risk</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Performance">Performance</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Narratives">Narratives</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Other">Other</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Nav className="ml-auto" style={{ marginRight: '40px' }}>
                    {
                      this.state.action_type === 'Edit' ? (
                        <GButton

                          onClick={() => this.handleApprove()}
                          type="Primary"
                          size="Medium"
                          text="Approve"
                        />
                      ) : (
                        <GButton
                          onClick={() => this.handleReject()}
                          text="Re-Open"
                          type="Primary"
                          size="Medium"
                        />
                      )
                    }
                  </Nav>
                  <Nav>
                    <Navbar.Collapse className="justify-content-end">
                      <Navbar.Text>
                        {this.state.Class_Code + ' - ' }
                        <a style={{ color: '#6F08CD' }}>{this.state.eventKey}</a>
                      </Navbar.Text>
                    </Navbar.Collapse>
                    {
                      this.state.loading ? <Spinner text="Loading data..." /> : (
                        this.gridApi && (
                          <Toolbar
                            api={this.gridApi}
                            working={this.state.toolbarWorking}
                            exportName={this.state.api_name}
                            controls={this.state.toolbarButtons}
                            count={{
                              total: this.state.totalRowCount,
                              showing: this.state.displayedRowCount,
                            }}
                          />
                        )
                      )
                    }
                  </Nav>
                </Navbar>
                <Row style={{ display: 'flex', flexDirection: '1', flexGrow: '1' }} className="no-padding">
                  {
                    this.state.eventKey === 'General Info' && (
                    <Col>
                      <Form
                        noValidate
                        validated={this.state.validated}
                        onSubmit={(e) => this.handleSubmit(e, 'General')}
                      >
                        <Row>
                          <Col>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00010_Portfolio_Issuer_Name'}
                                >
                                  Name of Issuer of Fund  or Share Class. or segregated account manager or financial instrument.
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00010_Portfolio_Issuer_Name.controlID">
                                <Form.Label>00010_Portfolio_Issuer_Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00010_Portfolio_Issuer_Name"
                                  value={this.state.x_00010_Portfolio_Issuer_Name}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder=""
                                />
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00020_Portfolio_Guarantor_Name'}
                                >
                                  Name of Guarantor of the financial instrument or fund... i.e. the entity to which the end investor has counterparty risk
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00020_Portfolio_Guarantor_Name.controlID">
                                <Form.Label>00020_Portfolio_Guarantor_Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00020_Portfolio_Guarantor_Name"
                                  value={this.state.x_00020_Portfolio_Guarantor_Name}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder=""
                                />
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>

                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00030_Portfolio_Identifying_Data'}
                                >
                                  Identification of the fund or share class or segregated account
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00030_Portfolio_Identifying_Data.controlID">
                                <Form.Label>00030_Portfolio_Identifying_Data</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#F8F8FF' : '#F8F8FF' }}
                                  name="x_00030_Portfolio_Identifying_Data"
                                  value={this.state.x_00030_Portfolio_Identifying_Data}
                                  onChange={this.handleInputChange}
                                  disabled
                                  placeholder=""
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required.
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio'}
                                >
                                  One of the options in the following closed list to be used:
                                  1 - ISO 6166 for ISIN code
                                  2 - CUSIP (The Committee on Uniform Securities Identification Procedures number assigned by the CUSIP Service Bureau for U.S. and Canadian companies)
                                  3 - SEDOL (Stock Exchange Daily Official List for the London Stock Exchange)
                                  4 – WKN (Wertpapier Kenn-Nummer, the alphanumeric German identification number)
                                  5 - Bloomberg Ticker (Bloomberg letters code that identify a company's securities)
                                  6 - BBGID (The Bloomberg Global ID)
                                  7 - Reuters RIC (Reuters instrument code)
                                  8 – FIGI (Financial Instrument Global Identifier)
                                  9 - Other code by members of the Association of National Numbering Agencies
                                  99 - Code attributed by the undertaking
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio.controlID">
                                <Form.Label>00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio"
                                  value={this.state.x_00040_Type_Of_Identification_Code_For_The_Fund_Share_Or_Portfolio}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder="1-9, 99"
                                  pattern="(1|2|3|4|5|6|7|8|9|99)"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required and must be one of the following values: 1, 2, 3, 4, 5, 6, 7, 8, 9, 99
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>

                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00050_Portfolio_Name'}
                                >
                                  Name of the Portfolio or name of the CIS
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00050_Portfolio_Name.controlID">
                                <Form.Label>00050_Portfolio_Name</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00050_Portfolio_Name"
                                  value={this.state.x_00050_Portfolio_Name}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder="255 Character Limit"

                                  maxLength="255"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required and cannot be longer than 255 characters.
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>

                          </Col>
                          <Col>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00060_Share_Class_Currency'}
                                >
                                  Valuation currency of the portfolio or the share class
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00060_Share_Class_Currency.controlID">
                                <Form.Label>00060_Share_Class_Currency</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00060_Share_Class_Currency"
                                  value={this.state.x_00060_Share_Class_Currency}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder="ISO 4217 Currency Code"
                                  pattern="(AED|AFN|ALL|AMD|ANG|AOA|ARS|AUD|AWG|AZN|BAM|BBD|BDT|BGN|BHD|BIF|BMD|BND|BOB|BOV|BRL|BSD|BTN|BWP|BYN|BZD|CAD|CDF|CHE|CHF|CHW|CLF|CLP|CNY|COP|COU|CRC|CUC|CUP|CVE|CZK|DJF|DKK|DOP|DZD|EGP|ERN|ETB|EUR|FJD|FKP|GBP|GEL|GHS|GIP|GMD|GNF|GTQ|GYD|HKD|HNL|HRK|HTG|HUF|IDR|ILS|INR|IQD|IRR|ISK|JMD|JOD|JPY|KES|KGS|KHR|KMF|KPW|KRW|KWD|KYD|KZT|LAK|LBP|LKR|LRD|LSL|LYD|MAD|MDL|MGA|MKD|MMK|MNT|MOP|MRU[13]|MUR|MVR|MWK|MXN|MXV|MYR|MZN|NAD|NGN|NIO|NOK|NPR|NZD|OMR|PAB|PEN|PGK|PHP|PKR|PLN|PYG|QAR|RON|RSD|RUB|RWF|SAR|SBD|SCR|SDG|SEK|SGD|SHP|SLL|SOS|SRD|SSP|STN[15]|SVC|SYP|SZL|THB|TJS|TMT|TND|TOP|TRY|TTD|TWD|TZS|UAH|UGX|USD|USN|UYI|UYU|UYW|UZS|VES|VND|VUV|WST|XAF|XAG|XAU|XBA|XBB|XBC|XBD|XCD|XDR|XOF|XPD|XPF|XPT|XSU|XTS|XUA|XXX|YER|ZAR|ZMW|ZWL)"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required and must be one of the following values: AED, AFN, ALL, AMD, ANG, AOA, ARS, AUD, AWG, AZN, BAM, BBD, BDT, BGN, BHD, BIF, BMD, BND, BOB, BOV, BRL, BSD, BTN, BWP, BYN, BZD, CAD, CDF, CHE, CHF, CHW, CLF, CLP, CNY, COP, COU, CRC, CUC, CUP, CVE, CZK, DJF, DKK, DOP, DZD, EGP, ERN, ETB, EUR, FJD, FKP, GBP, GEL, GHS, GIP, GMD, GNF, GTQ, GYD, HKD, HNL, HRK, HTG, HUF, IDR, ILS, INR, IQD, IRR, ISK, JMD, JOD, JPY, KES, KGS, KHR, KMF, KPW, KRW, KWD, KYD, KZT, LAK, LBP, LKR, LRD, LSL, LYD, MAD, MDL, MGA, MKD, MMK, MNT, MOP, MRU[13], MUR, MVR, MWK, MXN, MXV, MYR, MZN, NAD, NGN, NIO, NOK, NPR, NZD, OMR, PAB, PEN, PGK, PHP, PKR, PLN, PYG, QAR, RON, RSD, RUB, RWF, SAR, SBD, SCR, SDG, SEK, SGD, SHP, SLL, SOS, SRD, SSP, STN[15], SVC, SYP, SZL, THB, TJS, TMT, TND, TOP, TRY, TTD, TWD, TZS, UAH, UGX, USD, USN, UYI, UYU, UYW, UZS, VES, VND, VUV, WST, XAF, XAG, XAU, XBA, XBB, XBC, XBD, XCD, XDR, XOF, XPD, XPF, XPT, XSU, XTS, XUA, XXX, YER, ZAR, ZMW, ZWL
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00070_Reference_Date'}
                                >
                                  Date of reference.
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00070_Reference_Date.controlID">
                                <Form.Label>00070_Reference_Date</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#F8F8FF' : '#F8F8FF' }}
                                  name="x_00070_Reference_Date"
                                  value={this.state.x_00070_Reference_Date}
                                  onChange={this.handleInputChange}
                                  disabled
                                  placeholder="YYYY-MM-DD"
                                  pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required and must be a date in the format YYYY-MM-DD
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00080_Portfolio_PRIIPS_Category'}
                                >
                                  PRIIPS Category of the Portfolio
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00080_Portfolio_PRIIPS_Category.controlID">
                                <Form.Label>00080_Portfolio_PRIIPS_Category</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00080_Portfolio_PRIIPS_Category"
                                  value={this.state.x_00080_Portfolio_PRIIPS_Category}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder="1-4"
                                  pattern="[1-4]{1}"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field is required and must be one of the following values: 1, 2, 3, 4
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00090_Fund_CIC_code'}
                                >
                                  CIC code - Fund   (4 digits)
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00090_Fund_CIC_code.controlID">
                                <Form.Label>00090_Fund_CIC_code</Form.Label>
                                <Form.Control
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00090_Fund_CIC_code"
                                  value={this.state.x_00090_Fund_CIC_code}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder=""
                                />
                                <Form.Control.Feedback type="invalid">
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                            <OverlayTrigger
                              trigger="hover"
                              placement="right"
                              overlay={(
                                <Popover
                                  id={'popover-00100_EOS_portfolio'}
                                >
                                  Indicator whether the portfolio targets specific environmental or social objectives.
                                </Popover>
                              )}
                            >
                              <Form.Group controlId="00100_EOS_portfolio.controlID">
                                <Form.Label>00100_EOS_portfolio</Form.Label>
                                <Form.Control
                                  type="text"
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                  name="x_00100_EOS_portfolio"
                                  value={this.state.x_00100_EOS_portfolio}
                                  onChange={this.handleInputChange}
                                  disabled={this.state.action_type === 'Edit' ? false : true}
                                  placeholder="Y / N"
                                  pattern="(Y|N)"
                                />
                                <Form.Control.Feedback type="invalid">
                                  This field must be one of the following values: Y, N
                                </Form.Control.Feedback>
                              </Form.Group>
                            </OverlayTrigger>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ButtonToolbar>
                              {
                                this.state.action_type === 'Edit' ? (
                                  <Button
                                    style={{
                                      backgroundColor: '#6F08CD',
                                      border: '1px hidden',
                                      borderRadius: '100px',
                                      letterSpacing: '1.25px',
                                      marginLeft: '5px',
                                      marginRight: '5px',
                                      minHeight: '24px',
                                      padding: '0.5rem 1.2rem',
                                    }}
                                    variant="primary"
                                    type="submit"
                                  >
                                    Save
                                  </Button>
                                ) : null
                              }
                              <GButton
                                type="Secondary"
                                size="Medium"
                                onClick={() => { this.setState({ redirect: true }); }}
                                text="Cancel"
                              />
                            </ButtonToolbar>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                    )
                  }
                  {
                    this.state.eventKey === 'Costs' && (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={(e) => this.handleSubmit(e, 'Costs')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03010_One_off_cost_Portfolio_entry_cost'}
                                  >
                                    Subscription fees not acquired to the fund or the share class or portfolio mandate. Expressed as a % of the amount to be invested
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03010_One_off_cost_Portfolio_entry_cost.controlID">
                                  <Form.Label>03010_One_off_cost_Portfolio_entry_cost</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03010_One_off_cost_Portfolio_entry_cost"
                                    value={this.state.x_03010_One_off_cost_Portfolio_entry_cost}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03015_One_off_cost_Portfolio_entry_cost_Acquired'}
                                  >
                                    Subscription fees acquired to the fund or the share class or portfolio mandate. Expressed as a % of the amount to be invested
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03015_One_off_cost_Portfolio_entry_cost_Acquired.controlID">
                                  <Form.Label>03015_One_off_cost_Portfolio_entry_cost_Acquired</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03015_One_off_cost_Portfolio_entry_cost_Acquired"
                                    value={this.state.x_03015_One_off_cost_Portfolio_entry_cost_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03020_One_off_costs_Portfolio_exit_cost_at_RHP'}
                                  >
                                    exit fees at the end of RHP for the portfolio or fund or share class. It is expressed as a % of net asset value.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03020_One_off_costs_Portfolio_exit_cost_at_RHP.controlID">
                                  <Form.Label>03020_One_off_costs_Portfolio_exit_cost_at_RHP</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03020_One_off_costs_Portfolio_exit_cost_at_RHP"
                                    value={this.state.x_03020_One_off_costs_Portfolio_exit_cost_at_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03030_One_off_costs_Portfolio_exit_cost_at_1_year'}
                                  >
                                    exit fees after one year for the portfolio or fund or share class. It is expressed as a % of net asset value.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03030_One_off_costs_Portfolio_exit_cost_at_1_year.controlID">
                                  <Form.Label>03030_One_off_costs_Portfolio_exit_cost_at_1_year</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03030_One_off_costs_Portfolio_exit_cost_at_1_year"
                                    value={this.state.x_03030_One_off_costs_Portfolio_exit_cost_at_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03040_One_off_costs_Portfolio_exit_cost_at_half_RHP'}
                                  >
                                    exit fees after half of the RHP for the portfolio or fund or share class. It is expressed as a % of net asset value.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03040_One_off_costs_Portfolio_exit_cost_at_half_RHP.controlID">
                                  <Form.Label>03040_One_off_costs_Portfolio_exit_cost_at_half_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03040_One_off_costs_Portfolio_exit_cost_at_half_RHP"
                                    value={this.state.x_03040_One_off_costs_Portfolio_exit_cost_at_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator'}
                                  >
                                    Indicates whether there is a sliding exit cost or not
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator.controlID">
                                  <Form.Label>03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator"
                                    value={this.state.x_03050_One_off_costs_Portfolio_sliding_exit_cost_Indicator}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03060_Ongoing_costs_Portfolio_other_costs'}
                                  >
                                    See PRIIPS definition as a % of NAV of the portfolio, the funds or the share class / per annum
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03060_Ongoing_costs_Portfolio_other_costs.controlID">
                                  <Form.Label>03060_Ongoing_costs_Portfolio_other_costs</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03060_Ongoing_costs_Portfolio_other_costs"
                                    value={this.state.x_03060_Ongoing_costs_Portfolio_other_costs}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03070_Ongoing_costs_Portfolio_management_costs'}
                                  >
                                    Management fees as a % of the NAV
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03070_Ongoing_costs_Portfolio_management_costs.controlID">
                                  <Form.Label>03070_Ongoing_costs_Portfolio_management_costs</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03070_Ongoing_costs_Portfolio_management_costs"
                                    value={this.state.x_03070_Ongoing_costs_Portfolio_management_costs}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03080_Ongoing_costs_Portfolio_transaction_costs'}
                                  >
                                    See PRIIPS definition as a % of NAV of the portfolio, the funds or the share class / per annum.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03080_Ongoing_costs_Portfolio_transaction_costs.controlID">
                                  <Form.Label>03080_Ongoing_costs_Portfolio_transaction_costs</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03080_Ongoing_costs_Portfolio_transaction_costs"
                                    value={this.state.x_03080_Ongoing_costs_Portfolio_transaction_costs}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03090_Existing_performance_fees'}
                                  >
                                    Indicates whether there are existing performance fees or not
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03090_Existing_performance_fees.controlID">
                                  <Form.Label>03090_Existing_performance_fees</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03090_Existing_performance_fees"
                                    value={this.state.x_03090_Existing_performance_fees}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03095_Incidental_costs_Portfolio_performance_fees'}
                                  >
                                    See PRIIPS definition as a % of NAV of the portfolio, the funds or the share class / per annum
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03095_Incidental_costs_Portfolio_performance_fees.controlID">
                                  <Form.Label>03095_Incidental_costs_Portfolio_performance_fees</Form.Label>
                                  <Form.Control
                                    required={this.state.x_03090_Existing_performance_fees === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03095_Incidental_costs_Portfolio_performance_fees"
                                    value={this.state.x_03095_Incidental_costs_Portfolio_performance_fees}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 03090_Existing_performance_fees = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03100_Existing_carried_interest_fees'}
                                  >
                                    Indicates whether there are exiting carried interest fees or not
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03100_Existing_carried_interest_fees.controlID">
                                  <Form.Label>03100_Existing_carried_interest_fees</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03100_Existing_carried_interest_fees"
                                    value={this.state.x_03100_Existing_carried_interest_fees}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03105_Incidental_costs_Portfolio_carried_interest'}
                                  >
                                    See PRIIPS definition as a % of invested capital per annum (average)
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03105_Incidental_costs_Portfolio_carried_interest.controlID">
                                  <Form.Label>03105_Incidental_costs_Portfolio_carried_interest</Form.Label>
                                  <Form.Control
                                    required={this.state.x_03100_Existing_carried_interest_fees === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03105_Incidental_costs_Portfolio_carried_interest"
                                    value={this.state.x_03105_Incidental_costs_Portfolio_carried_interest}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 03100_Existing_carried_interest_fees = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    )
                  }
                  {
                    this.state.eventKey === 'Risk' && (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={(e) => this.handleSubmit(e, 'Risk')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01010_Valuation_Frequency'}
                                  >
                                    {
                                      'Number of valuation days per year for the portfolio or fund or share class.  Frequency ("0" = other than /"1"= annual  / "2"= biannual / "4"=quarterly / "12"= monthly / "24"=bimonthly / "52"=weekly / "104"=biweekly, "252"=daily)'
                                    }
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01010_Valuation_Frequency.controlID">
                                  <Form.Label>01010_Valuation_Frequency</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01010_Valuation_Frequency"
                                    value={this.state.x_01010_Valuation_Frequency}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="0, 1, 2, 4, 12, 24, 52, 104, 252"
                                    pattern="(0|1|2|4|12|24|52|104|252)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: 0, 1, 2, 4, 12, 24, 52, 104, 252
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01020_Portfolio_VEV_Reference'}
                                  >
                                    VEV of the Portfolio/Share Class
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01020_Portfolio_VEV_Reference.controlID">
                                  <Form.Label>01020_Portfolio_VEV_Reference</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' || this.state.x_00080_Portfolio_PRIIPS_Category === '3' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01020_Portfolio_VEV_Reference"
                                    value={this.state.x_01020_Portfolio_VEV_Reference}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 or 3 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01030_IS_Flexible'}
                                  >
                                    Indicator to alert if the portfolio is flexible. If the annex 2 section 14 of the regulation applies
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01030_IS_Flexible.controlID">
                                  <Form.Label>01030_IS_Flexible</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01030_IS_Flexible"
                                    value={this.state.x_01030_IS_Flexible}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01040_Flex_VEV_Historical'}
                                  >
                                    VaR Equivalent Volatility of the portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01040_Flex_VEV_Historical.controlID">
                                  <Form.Label>01040_Flex_VEV_Historical</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01030_IS_Flexible === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01040_Flex_VEV_Historical"
                                    value={this.state.x_01040_Flex_VEV_Historical}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01030_IS_Flexible = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01050_Flex_VEV_Ref_Asset_Allocation'}
                                  >
                                    VaR Equivalent volatility of the reference asset allocation of the portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01050_Flex_VEV_Ref_Asset_Allocation.controlID">
                                  <Form.Label>01050_Flex_VEV_Ref_Asset_Allocation</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01030_IS_Flexible === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01050_Flex_VEV_Ref_Asset_Allocation"
                                    value={this.state.x_01050_Flex_VEV_Ref_Asset_Allocation}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01030_IS_Flexible = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01060_IS_Risk_Limit_Relevant'}
                                  >
                                    Indicator to alert if there is a relevant risk limit fro flexible funds
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01060_IS_Risk_Limit_Relevant.controlID">
                                  <Form.Label>01060_IS_Risk_Limit_Relevant</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01030_IS_Flexible === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01060_IS_Risk_Limit_Relevant"
                                    value={this.state.x_01060_IS_Risk_Limit_Relevant}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01030_IS_Flexible = Y and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01070_Flex_VEV_Risk_Limit'}
                                  >
                                    VaR Equivalent volatility of the risk limit of the portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01070_Flex_VEV_Risk_Limit.controlID">
                                  <Form.Label>01070_Flex_VEV_Risk_Limit</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01030_IS_Flexible === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01070_Flex_VEV_Risk_Limit"
                                    value={this.state.x_01070_Flex_VEV_Risk_Limit}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01030_IS_Flexible = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                            </Col>
                            <Col>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01080_Existing_Credit_Risk'}
                                  >
                                    Indicator to alert if there is a credit risk
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01080_Existing_Credit_Risk.controlID">
                                  <Form.Label>01080_Existing_Credit_Risk</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01080_Existing_Credit_Risk"
                                    value={this.state.x_01080_Existing_Credit_Risk}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01090_SRI'}
                                  >
                                    Summary Indicator Risk of the fund or the portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01090_SRI.controlID">
                                  <Form.Label>01090_SRI</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01090_SRI"
                                    value={this.state.x_01090_SRI}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1-7"
                                    pattern="[1-7]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: 1, 2, 3, 4, 5, 6, 7
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01100_MRM'}
                                  >
                                    Market Risk Measure of the fund or portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01100_MRM.controlID">
                                  <Form.Label>01100_MRM</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01100_MRM"
                                    value={this.state.x_01100_MRM}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1-7"
                                    pattern="[1-7]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: 1, 2, 3, 4, 5, 6, 7
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01110_CRM'}
                                  >
                                    Credit Risk measure of the fund or the portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01110_CRM.controlID">
                                  <Form.Label>01110_CRM</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01110_CRM"
                                    value={this.state.x_01110_CRM}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1-6"
                                    pattern="[1-6]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: 1, 2, 3, 4, 5, 6
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01120_Recommended_Holding_Period'}
                                  >
                                    Recommended holding period of the fund
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01120_Recommended_Holding_Period.controlID">
                                  <Form.Label>01120_Recommended_Holding_Period</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01120_Recommended_Holding_Period"
                                    value={this.state.x_01120_Recommended_Holding_Period}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01130_Maturity_Date'}
                                  >
                                    Date of Maturity
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01130_Maturity_Date.controlID">
                                  <Form.Label>01130_Maturity_Date</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01130_Maturity_Date"
                                    value={this.state.x_01130_Maturity_Date}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="YYYY-MM-DD"
                                    pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: A date formatted as YYYY-MM-DD
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01140_Liquidity_Risk'}
                                  >
                                    Risk of Liquidity at the level of the fund or the portfolio, also used for narrative
                                    M = material liquidity risk, I = illiquid, L = no liquidity issue.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01140_Liquidity_Risk.controlID">
                                  <Form.Label>01140_Liquidity_Risk</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01140_Liquidity_Risk"
                                    value={this.state.x_01140_Liquidity_Risk}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="M, I, L"
                                    pattern="(M|I|L)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: M, I, L
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    )
                  }
                  {
                    this.state.eventKey === 'Performance' && (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={(e) => this.handleSubmit(e, 'Performance')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02010_Portfolio_return_unfavorable_scenario_1_year'}
                                  >
                                    Annual return  of the portfolio, fund, share class corresponding to the unfavorable scenario, after 1 year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02010_Portfolio_return_unfavorable_scenario_1_year.controlID">
                                  <Form.Label>02010_Portfolio_return_unfavorable_scenario_1_year</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 1 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02010_Portfolio_return_unfavorable_scenario_1_year"
                                    value={this.state.x_02010_Portfolio_return_unfavorable_scenario_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >1 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02020_Portfolio_return_unfavorable_scenario_half_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the unfavorable scenario, after half of the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02020_Portfolio_return_unfavorable_scenario_half_RHP.controlID">
                                  <Form.Label>
                                    02020_Portfolio_return_unfavorable_scenario_half_RHP
                                  </Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 2 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02020_Portfolio_return_unfavorable_scenario_half_RHP"
                                    value={this.state.x_02020_Portfolio_return_unfavorable_scenario_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02030_Portfolio_return_unfavorable_scenario_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the unfavorable scenario, at the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02030_Portfolio_return_unfavorable_scenario_RHP.controlID">
                                  <Form.Label>02030_Portfolio_return_unfavorable_scenario_RHP</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02030_Portfolio_return_unfavorable_scenario_RHP"
                                    value={this.state.x_02030_Portfolio_return_unfavorable_scenario_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02040_Portfolio_return_moderate_scenario_1_year'}
                                  >
                                    Return of the portfolio, fund, share class corresponding to the moderate scenario, after 1 year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02040_Portfolio_return_moderate_scenario_1_year.controlID">
                                  <Form.Label>02040_Portfolio_return_moderate_scenario_1_year</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 1 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02040_Portfolio_return_moderate_scenario_1_year"
                                    value={this.state.x_02040_Portfolio_return_moderate_scenario_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >1 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02050_Portfolio_return_moderate_scenario_half_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the moderate scenario, after half of the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02050_Portfolio_return_moderate_scenario_half_RHP.controlID">
                                  <Form.Label>
                                    02050_Portfolio_return_moderate_scenario_half_RHP</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 2 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02050_Portfolio_return_moderate_scenario_half_RHP"
                                    value={this.state.x_02050_Portfolio_return_moderate_scenario_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02060_Portfolio_return_moderate_scenario_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the moderate scenario, at the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02060_Portfolio_return_moderate_scenario_RHP.controlID">
                                  <Form.Label>02060_Portfolio_return_moderate_scenario_RHP</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02060_Portfolio_return_moderate_scenario_RHP"
                                    value={this.state.x_02060_Portfolio_return_moderate_scenario_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02070_Portfolio_return_favorable_scenario_1_year'}
                                  >
                                    Annual return  of the portfolio, fund, share class corresponding to the favorable scenario, after 1 year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02070_Portfolio_return_favorable_scenario_1_year.controlID">
                                  <Form.Label>02070_Portfolio_return_favorable_scenario_1_year</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 1 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02070_Portfolio_return_favorable_scenario_1_year"
                                    value={this.state.x_02070_Portfolio_return_favorable_scenario_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >1 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02080_Portfolio_return_favorable_scenario_half_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the favorable scenario, after half of the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02080_Portfolio_return_favorable_scenario_half_RHP.controlID">
                                  <Form.Label>02080_Portfolio_return_favorable_scenario_half_RHP</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 2 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02080_Portfolio_return_favorable_scenario_half_RHP"
                                    value={this.state.x_02080_Portfolio_return_favorable_scenario_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02090_Portfolio_return_favorable_scenario_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the favorable scenario, at the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02090_Portfolio_return_favorable_scenario_RHP.controlID">
                                  <Form.Label>02090_Portfolio_return_favorable_scenario_RHP</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02090_Portfolio_return_favorable_scenario_RHP"
                                    value={this.state.x_02090_Portfolio_return_favorable_scenario_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02100_Portfolio_return_stress_scenario_1_year'}
                                  >
                                    Annual return  of the portfolio, fund, share class corresponding to the stress scenario, after 1 year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02100_Portfolio_return_stress_scenario_1_year.controlID">
                                  <Form.Label>02100_Portfolio_return_stress_scenario_1_year</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 1 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02100_Portfolio_return_stress_scenario_1_year"
                                    value={this.state.x_02100_Portfolio_return_stress_scenario_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 01120_Recommended_Holding_Period >1 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02110_Portfolio_return_stress_scenario_half_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the stress scenario, after half of the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02110_Portfolio_return_stress_scenario_half_RHP.controlID">
                                  <Form.Label>02110_Portfolio_return_stress_scenario_half_RHP</Form.Label>
                                  <Form.Control
                                    required={this.state.x_01120_Recommended_Holding_Period > 2 ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02110_Portfolio_return_stress_scenario_half_RHP"
                                    value={this.state.x_02110_Portfolio_return_stress_scenario_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {'This field is required if 01120_Recommended_Holding_Period >2 and must be a valid decimal.'}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02120_Portfolio_return_stress_scenario_RHP'}
                                  >
                                    Average annual return of the portfolio, fund, share class corresponding to the stress scenario, at the RHP
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02120_Portfolio_return_stress_scenario_RHP.controlID">
                                  <Form.Label>02120_Portfolio_return_stress_scenario_RHP</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02120_Portfolio_return_stress_scenario_RHP"
                                    value={this.state.x_02120_Portfolio_return_stress_scenario_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02130_Portfolio_number_of_observed_return_M0'}
                                  >
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02130_Portfolio_number_of_observed_return_M0.controlID">
                                  <Form.Label>02130_Portfolio_number_of_observed_return_M0</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02130_Portfolio_number_of_observed_return_M0"
                                    value={this.state.x_02130_Portfolio_number_of_observed_return_M0}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02140_Portfolio_mean_observed_returns_M1'}
                                  >
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02140_Portfolio_mean_observed_returns_M1.controlID">
                                  <Form.Label>02140_Portfolio_mean_observed_returns_M1</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02140_Portfolio_mean_observed_returns_M1"
                                    value={this.state.x_02140_Portfolio_mean_observed_returns_M1}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-02150_Portfolio_observed_Sigma'}>
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02150_Portfolio_observed_Sigma.controlID">
                                  <Form.Label>02150_Portfolio_observed_Sigma</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02150_Portfolio_observed_Sigma"
                                    value={this.state.x_02150_Portfolio_observed_Sigma}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-02160_Portfolio_observed_Skewness'}>
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02160_Portfolio_observed_Skewness.controlID">
                                  <Form.Label>02160_Portfolio_observed_Skewness</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02160_Portfolio_observed_Skewness"
                                    value={this.state.x_02160_Portfolio_observed_Skewness}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02170_Portfolio_observed_Excess_Kurtosis'}
                                  >
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02170_Portfolio_observed_Excess_Kurtosis.controlID">
                                  <Form.Label>02170_Portfolio_observed_Excess_Kurtosis</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00080_Portfolio_PRIIPS_Category === '2' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02170_Portfolio_observed_Excess_Kurtosis"
                                    value={this.state.x_02170_Portfolio_observed_Excess_Kurtosis}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 00080_Portfolio_PRIIPS_Category = 2 and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-02180_Portfolio_observed_Stressed_Volatility'}>
                                    See PRIIPS regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02180_Portfolio_observed_Stressed_Volatility.controlID">
                                  <Form.Label>02180_Portfolio_observed_Stressed_Volatility</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02180_Portfolio_observed_Stressed_Volatility"
                                    value={this.state.x_02180_Portfolio_observed_Stressed_Volatility}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <GButton
                                  onClick={() => { this.setState({ redirect: true }); }}
                                  size="Medium"
                                  text="Cancel"
                                  type="Secondary"
                                />
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    )
                  }
                  {
                    this.state.eventKey === 'Narratives' && (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={(e) => this.handleSubmit(e, 'Narratives')}
                        >
                          <Row>
                            <Col>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04010_Reference_Language'}
                                  >
                                    Language in which all narratives/texts of this set of data are written
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04010_Reference_Language.controlID">
                                  <Form.Label>04010_Reference_Language</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#F8F8FF' : '#F8F8FF' }}
                                    name="x_04010_Reference_Language"
                                    value={this.state.x_04010_Reference_Language}
                                    onChange={this.handleInputChange}
                                    disabled
                                    placeholder="ISO 639-2 Language Code"
                                    pattern="(aar|abk|ace|ach|ada|ady|afa|afh|afr|ain|aka|akk|alb|ale|alg|alt|amh|ang|anp|apa|ara|arc|arg|arm|arn|arp|art|arw|asm|ast|ath|aus|ava|ave|awa|aym|aze|bad|bai|bak|bal|bam|ban|baq|bas|bat|bej|bel|bem|ben|ber|bho|bih|bik|bin|bis|bla|bnt|bod|bos|bra|bre|btk|bua|bug|bul|bur|byn|cad|cai|car|cat|cau|ceb|cel|ces|cha|chb|che|chg|chi|chk|chm|chn|cho|chp|chr|chu|chv|chy|cmc|cnr|cop|cor|cos|cpe|cpf|cpp|cre|crh|crp|csb|cus|cym|cze|dak|dan|dar|day|del|den|deu|dgr|din|div|doi|dra|dsb|dua|dum|dut|dyu|dzo|efi|egy|eka|ell|elx|eng|enm|epo|est|eus|ewe|ewo|fan|fao|fas|fat|fij|fil|fin|fiu|fon|fra|fre|frm|fro|frr|frs|fry|ful|fur|gaa|gay|gba|gem|geo|ger|gez|gil|gla|gle|glg|glv|gmh|goh|gon|gor|got|grb|grc|gre|grn|gsw|guj|gwi|hai|hat|hau|haw|heb|her|hil|him|hin|hit|hmn|hmo|hrv|hsb|hun|hup|hye|iba|ibo|ice|ido|iii|ijo|iku|ile|ilo|ina|inc|ind|ine|inh|ipk|ira|iro|isl|ita|jav|jbo|jpn|jpr|jrb|kaa|kab|kac|kal|kam|kan|kar|kas|kat|kau|kaw|kaz|kbd|kha|khi|khm|kho|kik|kin|kir|kmb|kok|kom|kon|kor|kos|kpe|krc|krl|kro|kru|kua|kum|kur|kut|lad|lah|lam|lao|lat|lav|lez|lim|lin|lit|lol|loz|ltz|lua|lub|lug|lui|lun|luo|lus|mac|mad|mag|mah|mai|mak|mal|man|mao|map|mar|mas|may|mdf|mdr|men|mga|mic|min|mis|mkd|mkh|mlg|mlt|mnc|mni|mno|moh|mon|mos|mri|msa|mul|mun|mus|mwl|mwr|mya|myn|myv|nah|nai|nap|nau|nav|nbl|nde|ndo|nds|nep|new|nia|nic|niu|nld|nno|nob|nog|non|nor|nqo|nso|nub|nwc|nya|nym|nyn|nyo|nzi|oci|oji|ori|orm|osa|oss|ota|oto|paa|pag|pal|pam|pan|pap|pau|peo|per|phi|phn|pli|pol|pon|por|pra|pro|pus|qaa|que|raj|rap|rar|roa|roh|rom|ron|rum|run|rup|rus|sad|sag|sah|sai|sal|sam|san|sas|sat|scn|sco|sel|sem|sga|sgn|shn|sid|sin|sio|sit|sla|slo|slk|slv|sma|sme|smi|smj|smn|smo|sms|sna|snd|snk|sog|som|son|sot|spa|sqi|srd|srn|srp|srr|ssa|ssw|suk|sun|sus|sux|swa|swe|syc|syr|tah|tai|tam|tat|tel|tem|ter|tet|tgk|tgl|tha|tib|tig|tir|tiv|tkl|tlh|tli|tmh|tog|ton|tpi|tsi|tsn|tso|tuk|tum|tup|tur|tut|tvl|twi|tyv|udm|uga|uig|ukr|umb|und|urd|uzb|vai|ven|vie|vol|vot|wak|wal|war|was|wel|wen|wln|wol|xal|xho|yao|yap|yid|yor|ypk|zap|zbl|zen|zgh|zha|zho|znd|zul|zun|zxx|zza)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: aar, abk, ace, ach, ada, ady, afa, afh, afr, ain, aka, akk, alb, ale, alg, alt, amh, ang, anp, apa, ara, arc, arg, arm, arn, arp, art, arw, asm, ast, ath, aus, ava, ave, awa, aym, aze, bad, bai, bak, bal, bam, ban, baq, bas, bat, bej, bel, bem, ben, ber, bho, bih, bik, bin, bis, bla, bnt, bod, bos, bra, bre, btk, bua, bug, bul, bur, byn, cad, cai, car, cat, cau, ceb, cel, ces, cha, chb, che, chg, chi, chk, chm, chn, cho, chp, chr, chu, chv, chy, cmc, cnr, cop, cor, cos, cpe, cpf, cpp, cre, crh, crp, csb, cus, cym, cze, dak, dan, dar, day, del, den, deu, dgr, din, div, doi, dra, dsb, dua, dum, dut, dyu, dzo, efi, egy, eka, ell, elx, eng, enm, epo, est, eus, ewe, ewo, fan, fao, fas, fat, fij, fil, fin, fiu, fon, fra, fre, frm, fro, frr, frs, fry, ful, fur, gaa, gay, gba, gem, geo, ger, gez, gil, gla, gle, glg, glv, gmh, goh, gon, gor, got, grb, grc, gre, grn, gsw, guj, gwi, hai, hat, hau, haw, heb, her, hil, him, hin, hit, hmn, hmo, hrv, hsb, hun, hup, hye, iba, ibo, ice, ido, iii, ijo, iku, ile, ilo, ina, inc, ind, ine, inh, ipk, ira, iro, isl, ita, jav, jbo, jpn, jpr, jrb, kaa, kab, kac, kal, kam, kan, kar, kas, kat, kau, kaw, kaz, kbd, kha, khi, khm, kho, kik, kin, kir, kmb, kok, kom, kon, kor, kos, kpe, krc, krl, kro, kru, kua, kum, kur, kut, lad, lah, lam, lao, lat, lav, lez, lim, lin, lit, lol, loz, ltz, lua, lub, lug, lui, lun, luo, lus, mac, mad, mag, mah, mai, mak, mal, man, mao, map, mar, mas, may, mdf, mdr, men, mga, mic, min, mis, mkd, mkh, mlg, mlt, mnc, mni, mno, moh, mon, mos, mri, msa, mul, mun, mus, mwl, mwr, mya, myn, myv, nah, nai, nap, nau, nav, nbl, nde, ndo, nds, nep, new, nia, nic, niu, nld, nno, nob, nog, non, nor, nqo, nso, nub, nwc, nya, nym, nyn, nyo, nzi, oci, oji, ori, orm, osa, oss, ota, oto, paa, pag, pal, pam, pan, pap, pau, peo, per, phi, phn, pli, pol, pon, por, pra, pro, pus, qaa, que, raj, rap, rar, roa, roh, rom, ron, rum, run, rup, rus, sad, sag, sah, sai, sal, sam, san, sas, sat, scn, sco, sel, sem, sga, sgn, shn, sid, sin, sio, sit, sla, slo, slk, slv, sma, sme, smi, smj, smn, smo, sms, sna, snd, snk, sog, som, son, sot, spa, sqi, srd, srn, srp, srr, ssa, ssw, suk, sun, sus, sux, swa, swe, syc, syr, tah, tai, tam, tat, tel, tem, ter, tet, tgk, tgl, tha, tib, tig, tir, tiv, tkl, tlh, tli, tmh, tog, ton, tpi, tsi, tsn, tso, tuk, tum, tup, tur, tut, tvl, twi, tyv, udm, uga, uig, ukr, umb, und, urd, uzb, vai, ven, vie, vol, vot, wak, wal, war, was, wel, wen, wln, wol, xal, xho, yao, yap, yid, yor, ypk, zap, zbl, zen, zgh, zha, zho, znd, zul, zun, zxx, zza
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04020_Comprehension_Alert_Portfolio'}
                                  >
                                    cf Art.14a + annex 1
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04020_Comprehension_Alert_Portfolio.controlID">
                                  <Form.Label>04020_Comprehension_Alert_Portfolio</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04020_Comprehension_Alert_Portfolio"
                                    value={this.state.x_04020_Comprehension_Alert_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04030_Intended_target_market_retail_investor_Portfolio'}
                                  >
                                    Text in reference language, as proposed by the asset manager

                                    The description of the type of retail investor to whom the PRIIP is intended to be marketed in the section entitled ‘What is this product?’ of the key information document shall include information on the target retail investors identified by the PRIIP manufacturer, in particular depending on the needs, characteristics and objectives of the type of client for whom the PRIIPs is compatible. This determination shall be based upon the ability of retail investors to bear investment loss and their investment horizon preferences, their theoretical knowledge of, and past experience with PRIIPs, the financial markets as well as the needs, characteristics and objectives of potential end clients.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04030_Intended_target_market_retail_investor_Portfolio.controlID">
                                  <Form.Label>04030_Intended_target_market_retail_investor_Portfolio</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04030_Intended_target_market_retail_investor_Portfolio"
                                    value={this.state.x_04030_Intended_target_market_retail_investor_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="750 Character Limit"

                                    maxLength="750"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and cannot be longer than 750 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04040_Investment_objective_Portfolio'}
                                  >
                                    Text in reference language, as proposed by the asset manager

                                    Information stating the objectives of the PRIIP and the means for achieving those objectives in the section entitled ‘What is this product?’ of the key information document shall be summarised in a brief, clear and easily understandable manner. That information shall identify the main factors upon which return depends, the underlying investment assets or reference values, and how the return is determined, as well as the relationship between the PRIIP’s return and that of the underlying investment assets or reference values.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04040_Investment_objective_Portfolio.controlID">
                                  <Form.Label>04040_Investment_objective_Portfolio</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04040_Investment_objective_Portfolio"
                                    value={this.state.x_04040_Investment_objective_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="2500 Character Limit"

                                    maxLength="2500"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and cannot be longer than 2500 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04050_Risk_narrative_Portfolio'}
                                  >
                                    Text in reference language, as proposed by the asset manager

                                    [insert a brief explanation of the classification of the product with a maximum of 300 characters in plain language]

                                    The field shall contain well-formulated text which can be used directly by the insurer in the KID according to article 14 of the regulation
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04050_Risk_narrative_Portfolio.controlID">
                                  <Form.Label>04050_Risk_narrative_Portfolio</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04050_Risk_narrative_Portfolio"
                                    value={this.state.x_04050_Risk_narrative_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="300 Character Limit"

                                    maxLength="300"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field cannot be longer than 300 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04060_Other_materially_relevant_risk_narrative_Portfolio'}
                                  >
                                    Text in reference language, as proposed by the asset managers : (Element E)
                                    [Where applicable: element h] [Other risks materially relevant to the PRIIP not included in the summary risk indicator to be explained with a maximum of 200 characters]
                                    The field shall contain well-formulated text which can be used directly by the insurer in the KID according to article 14 of the regulation.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04060_Other_materially_relevant_risk_narrative_Portfolio.controlID">
                                  <Form.Label>04060_Other_materially_relevant_risk_narrative_Portfolio</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04060_Other_materially_relevant_risk_narrative_Portfolio"
                                    value={this.state.x_04060_Other_materially_relevant_risk_narrative_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="200 Character Limit"

                                    maxLength="200"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and cannot be longer than 200 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04070_Type_of_underlying_Investment_Option'}
                                  >
                                    understandable to the customer
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04070_Type_of_underlying_Investment_Option.controlID">
                                  <Form.Label>04070_Type_of_underlying_Investment_Option</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04070_Type_of_underlying_Investment_Option"
                                    value={this.state.x_04070_Type_of_underlying_Investment_Option}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="300 Character Limit"

                                    maxLength="300"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and cannot be longer than 300 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04080_Capital_Guarantee'}
                                  >
                                    boolean to identify whether the portfolio has a general capital guarantee or not.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04080_Capital_Guarantee.controlID">
                                  <Form.Label>04080_Capital_Guarantee</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04080_Capital_Guarantee"
                                    value={this.state.x_04080_Capital_Guarantee}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04081_Capital_Guarantee_Level'}
                                  >
                                    Capital Guarantee level. Minimum amount will be paid at redemption in%. Cf annex 3, point 7, Element F
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04081_Capital_Guarantee_Level.controlID">
                                  <Form.Label>04081_Capital_Guarantee_Level</Form.Label>
                                  <Form.Control
                                    required={this.state.x_04080_Capital_Guarantee === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04081_Capital_Guarantee_Level"
                                    value={this.state.x_04081_Capital_Guarantee_Level}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 04080_Capital_Guarantee = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04082_Capital_Guarantee_Limitations'}
                                  >
                                    [insert a brief explanation of the guarantee limits of the product with a maximum of 300 characters in plain language]

                                    The field shall contain well-formulated text which can be used directly by the insurer in the KID according to article 14 of the regulation.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04082_Capital_Guarantee_Limitations.controlID">
                                  <Form.Label>04082_Capital_Guarantee_Limitations</Form.Label>
                                  <Form.Control
                                    required={this.state.x_04080_Capital_Guarantee === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04082_Capital_Guarantee_Limitations"
                                    value={this.state.x_04082_Capital_Guarantee_Limitations}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="300 Character Limit"

                                    maxLength="300"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 04080_Capital_Guarantee = Y and cannot be longer than 300 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04083_Capital_Guarantee_Early_Exit_Conditions'}
                                  >
                                    Date before which the early exit conditions apply.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04083_Capital_Guarantee_Early_Exit_Conditions.controlID">
                                  <Form.Label>04083_Capital_Guarantee_Early_Exit_Conditions</Form.Label>
                                  <Form.Control
                                    required={this.state.x_04080_Capital_Guarantee === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04083_Capital_Guarantee_Early_Exit_Conditions"
                                    value={this.state.x_04083_Capital_Guarantee_Early_Exit_Conditions}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="YYYY-MM-DD"
                                    pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 04080_Capital_Guarantee = Y and must be a date in the format YYYY-MM-DD
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04084_Capital_guarantee_Portfolio'}
                                  >
                                    characteristics of the guarantee: open ended or fixed maturity, daily or monthly lockin, monthly reset, constant guarantee, reference value (highest NAV, NAV of start period,…), other particularities, name of the guarantor
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04084_Capital_guarantee_Portfolio.controlID">
                                  <Form.Label>04084_Capital_guarantee_Portfolio</Form.Label>
                                  <Form.Control
                                    required={this.state.x_04080_Capital_Guarantee === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04084_Capital_guarantee_Portfolio"
                                    value={this.state.x_04084_Capital_guarantee_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="2500 Character Limit"

                                    maxLength="2500"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 04080_Capital_Guarantee = Y and cannot be longer than 2500 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04085_Possible_maximum_loss_Portfolio'}
                                  />
                                )}
                              >
                                <Form.Group controlId="04085_Possible_maximum_loss_Portfolio.controlID">
                                  <Form.Label>04085_Possible_maximum_loss_Portfolio</Form.Label>
                                  <Form.Control
                                    required={this.state.x_04080_Capital_Guarantee === 'Y' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04085_Possible_maximum_loss_Portfolio"
                                    value={this.state.x_04085_Possible_maximum_loss_Portfolio}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required if 04080_Capital_Guarantee = Y and must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04090_Portfolio_Performance_Fees_Narrative'}
                                  >
                                    Describes the outperformance of your product and shall be a well-formulated text.
                                    It shall be possible to enter the field into the sentence below.
                                    (annex VII  Table 2 )

                                    "The impact of the performance fee. We take these from your investment if the product outperforms its benchmark [y by x%]."
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04090_Portfolio_Performance_Fees_Narrative.controlID">
                                  <Form.Label>04090_Portfolio_Performance_Fees_Narrative</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04090_Portfolio_Performance_Fees_Narrative"
                                    value={this.state.x_04090_Portfolio_Performance_Fees_Narrative}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="300 Character Limit"

                                    maxLength="300"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field cannot be longer than 300 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04100_Portolio_Carried_Interest_Narrative'}
                                  >
                                    Describes the outperformance of your product and shall be a well-formulated text.
                                    It shall be possible to enter the field into the sentence below.
                                    (annex VII  Table 2 )

                                    "The impact of the carried interest We take these from your investment if the product outperforms its benchmark [y by x%]."
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04100_Portolio_Carried_Interest_Narrative.controlID">
                                  <Form.Label>04100_Portolio_Carried_Interest_Narrative</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04100_Portolio_Carried_Interest_Narrative"
                                    value={this.state.x_04100_Portolio_Carried_Interest_Narrative}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="300 Character Limit"

                                    maxLength="300"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field cannot be longer than 300 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-04110_Other_comment'}
                                  >
                                    This field shall be used only under exceptional circumstances and requires a manual review and might block automatic processing.

                                    This field is usually empty.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04110_Other_comment.controlID">
                                  <Form.Label>04110_Other_comment</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04110_Other_comment"
                                    value={this.state.x_04110_Other_comment}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }} variant="secondary" onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    )
                  }
                  {
                    this.state.eventKey === 'Other' && (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={(e) => this.handleSubmit(e, 'Other')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-05010_PRIIP_data_delivery'}>
                                    indicate if the line contains PRIIPS data or Not
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05010_PRIIP_data_delivery.controlID">
                                  <Form.Label>05010_PRIIP_data_delivery</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05010_PRIIP_data_delivery"
                                    value={this.state.x_05010_PRIIP_data_delivery}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-05020_UCITS_data_delivery'}>
                                    indicate if the line contains UCITS data or Not
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05020_UCITS_data_delivery.controlID">
                                  <Form.Label>05020_UCITS_data_delivery</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05020_UCITS_data_delivery"
                                    value={this.state.x_05020_UCITS_data_delivery}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05030_Portfolio_UCITS_SRRI'}
                                  >
                                    The SRRI of the Valid UCITS KIID
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05030_Portfolio_UCITS_SRRI.controlID">
                                  <Form.Label>05030_Portfolio_UCITS_SRRI</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05030_Portfolio_UCITS_SRRI"
                                    value={this.state.x_05030_Portfolio_UCITS_SRRI}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1-7"
                                    pattern="[1-7]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: 1, 2, 3, 4, 5, 6, 7
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05040_Portfolio_UCITS_Vol'}
                                  >
                                    If available - Historical volatility corresponding to the SRRI of the Valid UCITS KIID
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05040_Portfolio_UCITS_Vol.controlID">
                                  <Form.Label>05040_Portfolio_UCITS_Vol</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05040_Portfolio_UCITS_Vol"
                                    value={this.state.x_05040_Portfolio_UCITS_Vol}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05050_Ongoing_costs_Portfolio_other_costs_UCITS'}
                                  >
                                    See UCITS definition as a % of NAV of the portfolio, the funds or the share class / per annum
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05050_Ongoing_costs_Portfolio_other_costs_UCITS.controlID">
                                  <Form.Label>05050_Ongoing_costs_Portfolio_other_costs_UCITS</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05050_Ongoing_costs_Portfolio_other_costs_UCITS"
                                    value={this.state.x_05050_Ongoing_costs_Portfolio_other_costs_UCITS}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05060_Ongoing_costs_Portfolio_transaction_costs'}
                                  >
                                    See PRIIPS / UCITS definition as a % of NAV of the portfolio, the funds or the share class / per annum
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05060_Ongoing_costs_Portfolio_transaction_costs.controlID">
                                  <Form.Label>05060_Ongoing_costs_Portfolio_transaction_costs</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05060_Ongoing_costs_Portfolio_transaction_costs"
                                    value={this.state.x_05060_Ongoing_costs_Portfolio_transaction_costs}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-05065_Transactions_costs_methodology'}>
                                    1. New PRIIPS methodology
                                    2. Full PRIIPS methodology
                                    3. Other methodology
                                    4. None
                                    5. text
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05065_Transactions_costs_methodology.controlID">
                                  <Form.Label>05065_Transactions_costs_methodology</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05065_Transactions_costs_methodology"
                                    value={this.state.x_05065_Transactions_costs_methodology}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1-4, or Text"
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05070_Incidental_costs_Portfolio_performance_fees_UCITS'}
                                  >
                                    See UCITS definition as a % of NAV of the portfolio, the funds or the share class / per annum
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05070_Incidental_costs_Portfolio_performance_fees_UCITS.controlID">
                                  <Form.Label>05070_Incidental_costs_Portfolio_performance_fees_UCITS</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05070_Incidental_costs_Portfolio_performance_fees_UCITS"
                                    value={this.state.x_05070_Incidental_costs_Portfolio_performance_fees_UCITS}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05080_Incidental_costs_Portfolio_carried_interest_UCITS'}
                                  >
                                    See UCITS definition as a % of invested capital per annum (average)
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05080_Incidental_costs_Portfolio_carried_interest_UCITS.controlID">
                                  <Form.Label>05080_Incidental_costs_Portfolio_carried_interest_UCITS</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05080_Incidental_costs_Portfolio_carried_interest_UCITS"
                                    value={this.state.x_05080_Incidental_costs_Portfolio_carried_interest_UCITS}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-05090_UCITS_KID_Web_Address'}>
                                    Direct link to the UCITS Kid
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05090_UCITS_KID_Web_Address.controlID">
                                  <Form.Label>05090_UCITS_KID_Web_Address</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05090_UCITS_KID_Web_Address"
                                    value={this.state.x_05090_UCITS_KID_Web_Address}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="www.dfinsolutions.com"
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-06010_Bonds_Weight'}>
                                    Proportion (weight) of bonds and bonds futures within the fund/portfolio measured in percentage of market value.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06010_Bonds_Weight.controlID">
                                  <Form.Label>06010_Bonds_Weight</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06010_Bonds_Weight"
                                    value={this.state.x_06010_Bonds_Weight}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06020_Annualized_Return_Volatility'}
                                  >
                                    Annualized daily volatility of the fund / portfolio based on the last 250 trading days or, if valuation frequency is lower than daily, the volatility is based on the valuation frequency and annualized.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06020_Annualized_Return_Volatility.controlID">
                                  <Form.Label>06020_Annualized_Return_Volatility</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06020_Annualized_Return_Volatility"
                                    value={this.state.x_06020_Annualized_Return_Volatility}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06030_Duration_Bonds'}
                                  >
                                    Asset prices weighted Macaulay-Duration in years of the fund / portfolio
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06030_Duration_Bonds.controlID">
                                  <Form.Label>06030_Duration_Bonds</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06030_Duration_Bonds"
                                    value={this.state.x_06030_Duration_Bonds}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06040_Existing_Capital_Preservation'}
                                  >
                                    Identifies if a capital preservation method is used (Y) or not (N).
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06040_Existing_Capital_Preservation.controlID">
                                  <Form.Label>06040_Existing_Capital_Preservation</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06040_Existing_Capital_Preservation"
                                    value={this.state.x_06040_Existing_Capital_Preservation}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06050_Capital_Preservation_Level'}
                                  >
                                    100% minus the maximum possible loss in percentage of its market value.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06050_Capital_Preservation_Level.controlID">
                                  <Form.Label>06050_Capital_Preservation_Level</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06050_Capital_Preservation_Level"
                                    value={this.state.x_06050_Capital_Preservation_Level}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                            </Col>
                            <Col>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-06060_Time_Interval_Maximum_Loss'}>
                                    The time period in which a possible loss of a capital perservation funds is measured.  Frequency (/"1"= annual  / "2"= biannual / "4"=quarterly / "12"= monthly / "24"=bimonthly / "52"=weekly / "104"=biweekly/"252"=daily /"YYYY-MM-DD"=fixed date)
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06060_Time_Interval_Maximum_Loss.controlID">
                                  <Form.Label>06060_Time_Interval_Maximum_Loss</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06060_Time_Interval_Maximum_Loss"
                                    value={this.state.x_06060_Time_Interval_Maximum_Loss}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="0, 1, 2, 4, 12, 24, 52, 104, 252, YYYY-MM-DD"
                                    pattern="(0|1|2|4|12|24|52|104|252|^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: 0, 1, 2, 4, 12, 24, 52, 104, 252, or a date in YYYY-MM-DD
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06070_Uses_PI'}
                                  >
                                    Identifies if PI (Portfolio Insurance including CPPI Constant Proportion Portfolio Insurance)  is used (Y) or not (N) for capital preservation.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06070_Uses_PI.controlID">
                                  <Form.Label>06070_Uses_PI</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06070_Uses_PI"
                                    value={this.state.x_06070_Uses_PI}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y, N
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-06080_Multiplier_PI'}
                                  >
                                    Gives the maximum multiplier value if PI algorithm is used.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06080_Multiplier_PI.controlID">
                                  <Form.Label>06080_Multiplier_PI</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06080_Multiplier_PI"
                                    value={this.state.x_06080_Multiplier_PI}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07010_Total_cost_1_year'}
                                  >
                                    Total cost in 00060_Share_Class_Currency terms in case the investor cashes in after one year, as requested in the "Costs over time" table. Rebased to 1.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07010_Total_cost_1_year.controlID">
                                  <Form.Label>07010_Total_cost_1_year</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07010_Total_cost_1_year"
                                    value={this.state.x_07010_Total_cost_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07020_RIY_1_year'}
                                  >
                                    RIY in case the investor cashes in after one year, as requested in the "Costs over time" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07020_RIY_1_year.controlID">
                                  <Form.Label>07020_RIY_1_year</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07020_RIY_1_year"
                                    value={this.state.x_07020_RIY_1_year}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07030_Total_cost_half_RHP'}
                                  >
                                    Total cost in 00060_Share_Class_Currency terms in case the investor cashes in at the middle of the RHP, as requested in the "Costs over time" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07030_Total_cost_half_RHP.controlID">
                                  <Form.Label>07030_Total_cost_half_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07030_Total_cost_half_RHP"
                                    value={this.state.x_07030_Total_cost_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07040_RIY_half_RHP'}
                                  >
                                    RIY in case the investor cashes in at the middle of the RHP, as requested in the "Costs over time" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07040_RIY_half_RHP.controlID">
                                  <Form.Label>07040_RIY_half_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07040_RIY_half_RHP"
                                    value={this.state.x_07040_RIY_half_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07050_Total_cost_RHP'}
                                  >
                                    Total cost in 00060_Share_Class_Currency terms in case the investor cashes in at the RHP, as requested in the "Costs over time" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07050_Total_cost_RHP.controlID">
                                  <Form.Label>07050_Total_cost_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07050_Total_cost_RHP"
                                    value={this.state.x_07050_Total_cost_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07060_RIY_RHP'}
                                  >
                                    RIY in case the investor cashes in at the RHP, as requested in the "Costs over time" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07060_RIY_RHP.controlID">
                                  <Form.Label>07060_RIY_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07060_RIY_RHP"
                                    value={this.state.x_07060_RIY_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07070_One_off_costs_Portfolio_entry_cost_RIY'}
                                  >
                                    The entry cost in RIY terms, as requested in the "Composition of costs" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07070_One_off_costs_Portfolio_entry_cost_RIY.controlID">
                                  <Form.Label>07070_One_off_costs_Portfolio_entry_cost_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07070_One_off_costs_Portfolio_entry_cost_RIY"
                                    value={this.state.x_07070_One_off_costs_Portfolio_entry_cost_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07080_One_off_costs_Portfolio_exit_cost_RIY'}
                                  >
                                    The exit cost in RIY terms, as requested in the "Composition of costs" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07080_One_off_costs_Portfolio_exit_cost_RIY.controlID">
                                  <Form.Label>07080_One_off_costs_Portfolio_exit_cost_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07080_One_off_costs_Portfolio_exit_cost_RIY"
                                    value={this.state.x_07080_One_off_costs_Portfolio_exit_cost_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07090_Ongoing_costs_Portfolio_transaction_costs_RIY'}
                                  >
                                    {'The portfolio transaction costs in RIY terms, as requested in the "Composition of costs" table.'}
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07090_Ongoing_costs_Portfolio_transaction_costs_RIY.controlID">
                                  <Form.Label>07090_Ongoing_costs_Portfolio_transaction_costs_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07090_Ongoing_costs_Portfolio_transaction_costs_RIY"
                                    value={this.state.x_07090_Ongoing_costs_Portfolio_transaction_costs_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07100_Ongoing_costs_Other_ongoing_costs_RIY'}
                                  >
                                    The other ongoing costs in RIY terms, as requested in the "Composition of costs" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07100_Ongoing_costs_Other_ongoing_costs_RIY.controlID">
                                  <Form.Label>07100_Ongoing_costs_Other_ongoing_costs_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07100_Ongoing_costs_Other_ongoing_costs_RIY"
                                    value={this.state.x_07100_Ongoing_costs_Other_ongoing_costs_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07110_Incidental_costs_Portfolio_performance_fees_RIY'}
                                  >
                                    The performance fees in RIY terms, as requested in the "Composition of costs" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07110_Incidental_costs_Portfolio_performance_fees_RIY.controlID">
                                  <Form.Label>07110_Incidental_costs_Portfolio_performance_fees_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07110_Incidental_costs_Portfolio_performance_fees_RIY"
                                    value={this.state.x_07110_Incidental_costs_Portfolio_performance_fees_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="hover"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07120_Incidental_costs_Portfolio_carried_interests_RIY'}
                                  >
                                    The carried interests in RIY terms, as requested in the "Composition of costs" table.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07120_Incidental_costs_Portfolio_carried_interests_RIY.controlID">
                                  <Form.Label>07120_Incidental_costs_Portfolio_carried_interests_RIY</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07120_Incidental_costs_Portfolio_carried_interests_RIY"
                                    value={this.state.x_07120_Incidental_costs_Portfolio_carried_interests_RIY}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a valid decimal.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    )
                  }
                </Row>
              </>
            }
          </RegEditBody>
        </RegEditView>
      ));
  }
}

EPTv2editor.contextType = AppContext;

export default EPTv2editor;
